module.exports = __webpack_public_path__ + "static/media/loader.601348bb.svg";